import React from 'react';
import { useTranslation } from 'react-i18next';

import './WhySell.css';

const CARD_IMAGES = [
  'https://haatnexusprodinfosys.blob.core.windows.net/images/7 (1).png',
  'https://haatnexusprodinfosys.blob.core.windows.net/images/8 (2).png',
  'https://haatnexusprodinfosys.blob.core.windows.net/images/9 (1).png',
  'https://haatnexusprodinfosys.blob.core.windows.net/images/10 (2).png',
] as const;

const CARD_KEYS = ['card1', 'card2', 'card3', 'card4'] as const;

/**
 * "Why sell with us" landing section — a four-card value-prop grid. Each card
 * pairs a blob illustration with a short headline. Content is static and not
 * backend-wired.
 */
const WhySell: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="why-sell">
      <div className="wrap">
        <div className="grid">
          {CARD_KEYS.map((cardKey, index) => (
            <article key={cardKey} className={`card c${index + 1}`}>
              <div className="art">
                <img
                  className="ws-photo"
                  src={CARD_IMAGES[index]}
                  alt={t(`landingSections.whySell.${cardKey}.aria`) as string}
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <h3>{t(`landingSections.whySell.${cardKey}.title`)}</h3>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhySell;
